import { specialCharacters } from './enums/special-characters';

const isHeartbeat = payload => {
  return payload === specialCharacters.HEARTBEAT;
};

export { isHeartbeat };
